// extracted by mini-css-extract-plugin
module.exports = {"dropdownContent":"DropdownClick_dropdownContent__n4NqA","button":"DropdownClick_button__W6ehq"};